(function () {
  if (window.__AG_PB_TRY_ONCE_INIT__) return;
  window.__AG_PB_TRY_ONCE_INIT__ = true;

  // The Eyr campaign engine adds the campaign's gifts after the cart changes. Going to checkout straight away
  // would leave the page before it has, so wait for its check (at most 4 seconds), then go.
  function agGoToCheckout() {
    var engine = window.EyrCampaignEngine;
    var go = function () { window.location.href = '/checkout'; };
    if (!engine || typeof engine.sync !== 'function') return go();
    var done = false;
    var once = function () { if (!done) { done = true; go(); } };
    setTimeout(once, 4000);
    try { Promise.resolve(engine.sync()).then(once, once); } catch (e) { once(); }
  }

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function openMiniCart(cartData) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { cart: cartData, openMiniCart: true }
    }));

    var cartDrawer = document.querySelector('cart-drawer, #mini-cart');
    if (cartDrawer) {
      cartDrawer.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
    }

    if (typeof updateCartItemCount === 'function') {
      updateCartItemCount();
    }

    document.dispatchEvent(new CustomEvent('cart:changed', { bubbles: true }));
  }

  function initRoot(root) {
    if (!root || root.dataset.agPbTryOnceReady === 'true') return;
    root.dataset.agPbTryOnceReady = 'true';

    var form = qs('form[data-ag-pb-try-once-form]', root);
    if (!form) return;

    var mode = (form.getAttribute('data-cta-mode') || 'cart').toLowerCase();
    var inflight = false;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (inflight) return;

      var idInput = qs('input[name="id"]', form);
      var qtyInput = qs('input[name="quantity"]', form);
      var variantId = idInput ? String(idInput.value || '').trim() : '';
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (!qty || qty < 1) qty = 1;

      if (!/^\d+$/.test(variantId)) {
        console.error('[AG Try Once] Missing/invalid variant id');
        return;
      }

      var btn = qs('[data-ag-pb-try-once-btn]', root);
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      }
      inflight = true;

      /* One-time purchase: no selling_plan */
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: qty }]
        })
      })
        .then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok) throw body;
            return body;
          });
        })
        .then(function (addBody) {
          if (mode === 'checkout') {
            agGoToCheckout();
            return;
          }

          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              openMiniCart(cart || addBody);
            })
            .catch(function () {
              openMiniCart(addBody);
            });
        })
        .catch(function (err) {
          console.error('[AG Try Once ERROR]', err);
        })
        .finally(function () {
          inflight = false;
          if (btn && mode !== 'checkout') {
            btn.removeAttribute('aria-busy');
            btn.disabled = false;
          }
        });
    });
  }

  function initAll(scope) {
    var root = scope || document;
    qsa('[data-ag-pb-try-once]', root).forEach(initRoot);
    if (root.matches && root.matches('[data-ag-pb-try-once]')) initRoot(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) { initAll(e.target); });
})();
